(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shopthelook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-the-look')) {
    class ShopTheLook extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-stl-slide]'));
        this.panels = Array.from(this.querySelectorAll('[data-stl-panel]'));
        this.current = this.querySelector('[data-stl-current]');
        this.media = this.querySelector('[data-stl-media]');
        this.index = 0;

        this.querySelector('[data-stl-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-stl-next]')?.addEventListener('click', () => this.go(this.index + 1));

        this.media?.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1);
          if (e.key === 'ArrowRight') this.go(this.index + 1);
        });

        // Swipe between looks on touch screens
        let startX = null;
        this.media?.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        this.media?.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 50) this.go(this.index + (dx < 0 ? 1 : -1));
          startX = null;
        });

        this.addEventListener('click', this.onClick.bind(this));
        this.onOutsideClick = (e) => { if (!e.target.closest('[data-stl-card]')) this.closeSizes(); };
        this.onEscape = (e) => { if (e.key === 'Escape') this.closeSizes(); };
        document.addEventListener('click', this.onOutsideClick);
        document.addEventListener('keydown', this.onEscape);


        // Theme editor: jump to a look when its block is selected
        if (window.Shopify && Shopify.designMode) {
          this.onBlockSelect = (e) => {
            const i = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
            if (i > -1) this.go(i);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutsideClick);
        document.removeEventListener('keydown', this.onEscape);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      go(i) {
        const n = this.slides.length;
        if (!n) return;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => {
          s.classList.toggle('is-active', k === this.index);
          s.setAttribute('aria-hidden', k === this.index ? 'false' : 'true');
        });
        this.panels.forEach((p, k) => { p.hidden = k !== this.index; });
        if (this.current) this.current.textContent = this.index + 1;
        this.closeSizes();
      }

      onClick(e) {
        const size = e.target.closest('[data-stl-variant]');
        if (size) return this.addToCart(size.dataset.stlVariant, size.closest('[data-stl-card]'));

        if (e.target.closest('[data-stl-close]')) return this.closeSizes();

        const add = e.target.closest('[data-stl-quick-add]');
        if (add) {
          const card = add.closest('[data-stl-card]');
          if (add.dataset.variantId) return this.addToCart(add.dataset.variantId, card);
          const sizes = card.querySelector('[data-stl-sizes]');
          const open = sizes.hidden;
          this.closeSizes();
          sizes.hidden = !open;
          add.setAttribute('aria-expanded', String(open));
          if (open) sizes.querySelector('button:not([disabled]):not([data-stl-close])')?.focus();
        }
      }

      closeSizes() {
        this.querySelectorAll('[data-stl-sizes]').forEach((s) => { s.hidden = true; });
        this.querySelectorAll('[data-stl-quick-add][aria-expanded]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      }

      // Uses the theme's own cart drawer / notification when it is Dawn-based
      async addToCart(variantId, card) {
        const button = card.querySelector('[data-stl-quick-add]');
        button?.classList.add('is-loading');

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cart && typeof cart.getSectionsToRender === 'function'
          ? cart.getSectionsToRender().map((s) => s.id)
          : ['cart-icon-bubble'];

        try {
          const res = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1,
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');

          if (this.dataset.afterAdd === 'cart') {
            window.location.href = this.dataset.cartUrl;
            return;
          }

          this.closeSizes();
          this.flash(card, this.dataset.addedText);

          if (cart && typeof cart.renderContents === 'function') {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else if (data.sections && data.sections['cart-icon-bubble']) {
            const bubble = document.getElementById('cart-icon-bubble');
            const html = new DOMParser()
              .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section');
            if (bubble && html) bubble.innerHTML = html.innerHTML;
          }

          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'shop-the-look', productVariantId: variantId, cartData: data });
          }
          // Same event the theme's own product form fires: refreshes the cart count and opens the cart drawer
          document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('shop-the-look:added', { bubbles: true, detail: { variantId, item: data } }));
        } catch (err) {
          this.flash(card, err.message);
        } finally {
          button?.classList.remove('is-loading');
        }
      }

      flash(card, text) {
        const status = card.querySelector('[data-stl-status]');
        if (!status) return;
        status.textContent = text;
        status.classList.add('is-visible');
        clearTimeout(status._t);
        status._t = setTimeout(() => status.classList.remove('is-visible'), 2200);
      }
    }

    customElements.define('shop-the-look', ShopTheLook);
  }

  } catch(e) { console.error(e); }
})();
})();
